import React, { useEffect, useState, useContext } from 'react';
import {
  Table,
  Spinner,
  Alert,
  Button,
  Modal,
  Form, 
} from 'react-bootstrap';
import toast from 'react-hot-toast';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Pagination from 'react-bootstrap/Pagination';
import { PiCaretUpDownFill } from 'react-icons/pi';
import { FaArrowUpShortWide, FaArrowDownWideShort } from 'react-icons/fa6';
import { GlobalVarContext } from '../../../../../context/GlobalVarContext';
import { AuthContext } from '../../../../../context/AuthContext';
import { SideBarRefreshContext } from '../../../../../context/SideBarRefreshContext';
// import { PermissionContext } from '../../../../context/PermissionContext';

 
const RejectAccount = () => {
  const [restaurants, setRestaurants] = useState([]);
  const [filteredRestaurants, setFilteredRestaurants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { apiGlobal } = useContext(GlobalVarContext);
  const { restaurantid, currencyCode, countryId } = useContext(AuthContext);
  const { sideBarRefresh } = useContext(SideBarRefreshContext);
  const [payInfo, setPayInfo] = useState({});
  const [refresh, setRefresh] = useState(false);
  const [searchStartDate, setSearchStartDate] = useState('');
  const [searchEndDate, setSearchEndDate] = useState('');
//   const { permissionsAccess } = useContext(PermissionContext);
  
  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;

  const [sortOrder, setSortOrder] = useState('asc');
  const [sortColumn, setSortColumn] = useState('payment_date'); // This will track the column being sorted

  const handleSort = (column) => {
    const newSortOrder = sortColumn === column
    && sortOrder === 'asc' ? 'desc' : 'asc'; // Toggle order for the same column
    const sortedData = [...restaurants].sort((a, b) => {
      if (column === 'payment_date') {
        return newSortOrder === 'asc'
          ? a.payment_date.localeCompare(b.payment_date)
          : b.payment_date.localeCompare(a.payment_date);
          // eslint-disable-next-line
      } else if (column === 'amount') {
        return newSortOrder === 'asc'
        ? parseFloat(a.amount) - parseFloat(b.amount)
        : parseFloat(b.amount) - parseFloat(a.amount);
      } else if (column === 'balance') {
        return newSortOrder === 'asc'
        ? parseFloat(a.balance) - parseFloat(b.balance)
        : parseFloat(b.balance) - parseFloat(a.balance);
      }
      return 0;
    });
   
    setRestaurants(sortedData);
    setSortOrder(newSortOrder);
    setSortColumn(column); // Update the current sorted column
    };
  
 
  const fetchData = async () => {
    setLoading(true);
    setError(null);

    const formData = new FormData();
    formData.append('restaurant_id', restaurantid);
    formData.append('country_id', countryId);
    try {
      // You can append filters to formData if required
  
      const response = await fetch(`${apiGlobal}restaurant/payment_reject_list.php`, {
        method: 'POST',
        body: formData,
      });
  
      const data = await response.json();
  
      if (data?.status && data?.message === 'Success') {
        setRestaurants(data.data);
        setFilteredRestaurants(data.data);
      } else if (data?.status && data?.message === 'No data found') {
        setRestaurants([]);
        setFilteredRestaurants([]);
      } else {
        setError(data?.message || 'Unexpected error');
      }
    } catch (err) {
      setError('Failed to fetch restaurant account data');
    } finally {
      setLoading(false);
    }
  };
  
  // Fetch data on mount and when refresh state changes
  useEffect(() => {
    fetchData();
  }, [refresh, sideBarRefresh?.restaurantAccountRejectedRefresh]);

  useEffect(() => {
    let filteredData = [...restaurants];
  
    if (searchStartDate) {
      filteredData = filteredData.filter((restaurant) => {
        const paymentDate = new Date(restaurant?.payment_date);
        return paymentDate >= new Date(searchStartDate);
      });
    }
  
    if (searchEndDate) {
      filteredData = filteredData.filter((restaurant) => {
        const paymentDate = new Date(restaurant?.payment_date);
        return paymentDate <= new Date(searchEndDate);
      });
    }
  
    setFilteredRestaurants(filteredData);
    setCurrentPage(1); // Optional: Reset pagination when filter changes
  }, [searchStartDate, searchEndDate, restaurants]);

 // Format date from YYYY-MM-DD to DD-MM-YYYY
  const formatDate = (dateString) => {
    if (!dateString) return ''; // Handle empty values
    const [year, month, day] = dateString.split('-');
    return `${day}-${month}-${year}`;
  };
 
  // Handle page change
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Pagination Logic - Slice data for the current page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentRestaurants = filteredRestaurants.slice(indexOfFirstItem, indexOfLastItem);

  // Total pages
  const totalPages = Math.ceil(filteredRestaurants.length / itemsPerPage);

  // Spinner while loading
  if (loading) {
    return (
      <div className="text-center mt-4">
        <Spinner animation="grow" variant="primary" />
      </div>
    );
  }
 
  // Error display
  if (error) {
    return (
      <Alert variant="danger" className="text-center mt-4">
        {error}
      </Alert>
    );
  }
 
  return (
    <div>
      <Breadcrumbs
        aria-label="breadcrumb"
        sx={{
        marginBottom: '5px',
        marginLeft: '15px',
      }}
      >
        <Typography sx={{ color: 'text.primary' }}>Restaurant</Typography>
        <Typography sx={{ color: 'text.primary' }}>Restaurant Account</Typography>
        <Typography sx={{ color: 'text.primary' }}>Rejected Request</Typography>
      </Breadcrumbs>
      

      <div className="container">
        <div
          className="mb-4"
          style={{
            padding: '15px',
            borderRadius: '8px',
            backgroundColor: '#f8f9fa',
            display: 'flex',
            justifyContent: 'flex-start',
            gap: '20px',
            alignItems: 'center',
            flexWrap: 'nowrap',
          }}
        >
          {/* From Date */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <label htmlFor="searchStartDate" style={{ whiteSpace: 'nowrap' }}><b>From:</b></label>
            <Form.Control
              id="searchStartDate"
              type="date"
              placeholder="Start Date"
              value={searchStartDate}
              onChange={e => setSearchStartDate(e.target.value)}
              style={{
                borderRadius: '25px',
                padding: '8px',
                border: '1px solid #ddd',
                maxWidth: '160px',
              }}
            />
          </div>

          {/* To Date */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <label htmlFor="searchEndDate" style={{ whiteSpace: 'nowrap' }}><b>To:</b></label>
            <Form.Control
              id="searchEndDate"
              type="date"
              placeholder="End Date"
              value={searchEndDate}
              onChange={e => setSearchEndDate(e.target.value)}
              style={{
                borderRadius: '25px',
                padding: '8px',
                border: '1px solid #ddd',
                maxWidth: '160px',
              }}
            />
          </div>

          {/* Clear Button */}
          <Button
            variant="outline-danger"
            style={{
              borderRadius: '25px',
              padding: '8px 16px',
              marginLeft: '10px',
              alignSelf: 'center',
            }}
            onClick={() => {
              setSearchStartDate('');
              setSearchEndDate('');
            }}
          >
            Clear Filters
          </Button>
          <Button
            variant="outline-danger"
            style={{
              borderRadius: '25px',
              padding: '8px 16px',
              marginLeft: '2px',
              alignSelf: 'center',
            }}
            onClick={() => {
              setRefresh(prev => !prev);
              toast.success('Data refreshed successfully');
            }}
          >
            Refresh
          </Button>
        </div>


        {filteredRestaurants.length === 0 ? (
          <div className="text-center">No rejected payment found.</div>
        ) : (
          <Table
            responsive
            style={{
              backgroundColor: '#f9f9f9',
              borderRadius: '8px',
              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
            }}
          >
            <thead className="bg-danger" style={{ color: 'white', textAlign: 'center' }}>
              <tr>
                <th>Sr.no</th>
                <th onClick={() => handleSort('payment_date')} style={{ cursor: 'pointer' }}>
                  <PiCaretUpDownFill /> Payment Date {sortColumn === 'payment_date'
                  && (sortOrder === 'asc' ? <FaArrowUpShortWide /> : <FaArrowDownWideShort />)}
                </th>
                <th>Perticular</th>
                <th>Payment Type</th>
                <th onClick={() => handleSort('amount')} style={{ cursor: 'pointer' }}>
                  <PiCaretUpDownFill /> Amount {sortColumn === 'amount'
                  && (sortOrder === 'asc' ? <FaArrowUpShortWide /> : <FaArrowDownWideShort />)}
                </th>
                <th>Status</th>
                <th>Reason Remark</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {currentRestaurants.map((restaurant, index) => (
                <tr key={restaurant.id} style={{ textAlign: 'center', padding: '20px' }}>
                  <td>{indexOfFirstItem + index + 1}</td>
                  <td>{formatDate(restaurant.payment_date)}</td>
                  <td>{restaurant.booking === '1' ? 'Meal sold' : 'Transfer'}</td>
                  <td>
                    {(() => {
                switch (restaurant.payment_type) {
                  case '1':
                    return 'Cash';
                  case '3':
                    return 'NEFT/RTGS/IMPS';
                //   case '4':
                //     return 'On Account';
                  case '5':
                    return 'Cheque';
                  default:
                    return 'Unknown Payment Method';
                }
              })()}
                  </td>
                  <td>{parseFloat(restaurant?.amount || 0).toLocaleString()}</td>
                  <td><span className="text-danger">Rejected by reason</span></td>
                  <td>{restaurant?.remark}</td>
                  <td>
                    <Button 
                      type="button"
                      variant="outline-warning"
                      size="sm"
                      onClick={() => setPayInfo({
                        showModal: true,
                        paytype: restaurant.payment_type || 'NA',
                        paymentDate: restaurant.payment_date || 'NA',
                        paymentAmount: restaurant.amount || 'NA',
                        refNo: restaurant.ref_no || 'NA',
                        narration: restaurant.narration || 'NA',
                        bankName: restaurant.bank || 'NA',
                        chequeDate: restaurant.ref_date || 'NA',
                       })}
                    >Pay Info
                    </Button>
                    
                  </td>
                
                </tr>
              ))}
            </tbody>
          </Table>
        )}
        <div
          style={{
            bottom: '20px',
            right: '20px',
            zIndex: 999,
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
          }}
        >
          {filteredRestaurants.length > 0 && (
          <Pagination>
            <Pagination.Prev
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
            />
            {Array.from({ length: totalPages }, (_, index) => (
              <Pagination.Item
                key={index + 1}
                active={index + 1 === currentPage}
                onClick={() => handlePageChange(index + 1)}
              >
                {index + 1}
              </Pagination.Item>
              ))}
            <Pagination.Next
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages || totalPages === 0}
            />
          </Pagination>
          )}
        </div>
      
      </div>
      <Modal
        show={payInfo?.showModal}
        onHide={() => setPayInfo({
            showModal: false,
            paytype: '',
            paymentDate: '',
            paymentAmount: '',
            totalAmount: '',
            refNo: '',
            narration: '',
            bankName: '',
            chequeDate: '',
          })}
        centered
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title>Payment Information</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table
            responsive
            style={{
            backgroundColor: '#f9f9f9',
            borderRadius: '8px',
            boxShadow: '0 4px 8px rgba(178, 114, 114, 0.1)',
        }}
          >
            <thead className="bg-primary" style={{ color: 'white', textAlign: 'center' }}>
              <tr>
                <th>#</th>
                <th>Payment Date</th>
                <th>Payment Type</th>
                <th>Payment Amount</th>
                <th>Narration</th>
                <th>Ref No</th>
                <th>Bank Name</th>
                <th>Cheque Date</th>
              </tr>
            </thead>
            <tbody style={{ textAlign: 'center' }}>
              <tr>
                <td>{1}</td>
                <td>{formatDate(payInfo.paymentDate)}</td>
                <td>
                  {(() => {
                switch (payInfo.paytype) {
                  case '1':
                    return 'Cash';
                  case '3':
                    return 'NEFT/RTGS/IMPS';
                  case '4':
                    return 'On Account';
                  case '5':
                    return 'Cheque';
                  default:
                    return 'Unknown Payment Method';
                }
              })()}
                </td>
                <td>{payInfo.paymentAmount}</td>
                <td>{payInfo.narration}</td>
                <td>{payInfo.paytype !== '1' ? payInfo.refNo : 'NA'}</td>
                <td>{payInfo.paytype === '3' || payInfo.paytype === '5' ? payInfo.bankName : 'NA'}</td>
                <td> {payInfo.paytype === '5' ? formatDate(payInfo.chequeDate) : 'NA'}
                </td>
              </tr>
            </tbody>
          </Table>
        </Modal.Body>
      </Modal>
    </div>  
  );
};
 
export default RejectAccount;

